module.exports = __webpack_public_path__ + "img/ckko4.4fa37811.jpeg";